import axios from 'axios';

function publicRequest(opt) {
  const options = {
    method: opt.method || 'get',
    url: opt.url,
  };
  if (options.method === 'get') {
    options.params = opt.params || {};
  } else if (options.method === 'post') {
    options.data = opt.params || {};
  }
  return axios(options).then(res => res);
}

function apiRequest(opt) {
  const options = {
    method: opt.method || 'get',
    baseURL: '',
    url: opt.url,
  };
  if (options.method === 'get') {
    options.params = opt.params || {};
  } else if (options.method === 'post') {
    options.data = opt.params || {};
  }
  return axios(options).then(res => res);
}

export { publicRequest, apiRequest };
